import React, { useState, useEffect } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import TrainingPlanPage from './pages/TrainingPlanPage';
import Dashboard from './pages/Dashboard';
import RoutesPage from './pages/RoutesPage';
import RouteDetail from './pages/RouteDetail';
import SkillsPage from './pages/SkillsPage';
import FocusPage from './pages/FocusPage';
import ProjectsPage from './pages/ProjectsPage';
import IntegrationPage from './pages/IntegrationPage';
import { useGrowthPlannerStore } from './store/growthPlannerStore';

const TAB_KEYS = ['dashboard', 'formation', 'routes', 'skills', 'focus', 'projects', 'integration'];

export default function GrowthPlannerApp() {
  const [tab, setTab] = useState(0);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const [planRouteId, setPlanRouteId] = useState(null);
  const rehydrate = useGrowthPlannerStore((s) => s.rehydrate);

  useEffect(() => {
    rehydrate();
    const onSync = () => rehydrate();
    window.addEventListener('cloud-sync-complete', onSync);
    return () => window.removeEventListener('cloud-sync-complete', onSync);
  }, [rehydrate]);

  const handleNavigate = (target, routeId = null) => {
    const idx = TAB_KEYS.indexOf(target);
    if (idx >= 0) setTab(idx);
    if (routeId && target === 'formation') setPlanRouteId(routeId);
    if (routeId && target === 'routes') setSelectedRouteId(routeId);
  };

  const handleSelectRoute = (routeId) => {
    setSelectedRouteId(routeId);
  };

  const handleBackFromDetail = () => {
    setSelectedRouteId(null);
  };

  return (
    <Box sx={{ pb: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          <TrendingUpRoundedIcon sx={{ verticalAlign: 'middle', mr: 1, color: 'primary.main' }} />
          Growth Planner
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Planifica tu crecimiento profesional, mide progreso y construye CVs por objetivo
        </Typography>
      </Box>

      <Tabs
        value={tab}
        onChange={(_, v) => { setTab(v); if (v !== 2) setSelectedRouteId(null); }}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Dashboard" />
        <Tab label="Formación" />
        <Tab label="Rutas" />
        <Tab label="Skills" />
        <Tab label="Focus" />
        <Tab label="Proyectos" />
        <Tab label="CV" />
      </Tabs>

      <Box>
        {tab === 0 && <Dashboard onNavigate={handleNavigate} />}
        {tab === 1 && <TrainingPlanPage activeRouteId={planRouteId} onRouteChange={setPlanRouteId} />}
        {tab === 2 && (
          selectedRouteId
            ? <RouteDetail routeId={selectedRouteId} onBack={handleBackFromDetail} />
            : <RoutesPage selectedRouteId={selectedRouteId} onSelectRoute={handleSelectRoute} />
        )}
        {tab === 3 && <SkillsPage />}
        {tab === 4 && <FocusPage />}
        {tab === 5 && <ProjectsPage />}
        {tab === 6 && <IntegrationPage />}
      </Box>
    </Box>
  );
}
